import { PageBreak, Paragraph, TextRun, BorderStyle, HeadingLevel } from 'docx'
import SectionHeader from '../../SectionHeader'
import { parseDateToTaiwanDate } from '../../../ReportPDF/TaiwanDateConvert'

const Chapter2Page = ({ reportData }) => {
  const { reprotDao, phishCampaignReport, phishType, secondaryCompanyNickname } = reportData || {}
  const {
    companyName,
    campaignStartDate,
    campaignEndDate,
    sendTotalCount,
    sendSuccessCount,
    sendFailCount,
    userCount,
  } = reprotDao || {}
  const service = phishType
  const sendCount = userCount > 0 ? sendTotalCount / userCount : 0

  const {
    openCount,
    linkCount,
    fileCount,
    textCount,
    openPercent,
    linkPercent,
    filePercent,
    textPercent,
  } = phishCampaignReport || {}

  const formatPercent = value => {
    // 檢查是否存在且為數字，並且小數點後超過 2 位才進行處理
    if (value != null) {
      const strValue = value.toString()
      const decimalPart = strValue.split('.')[1] // 小數部分
      return decimalPart && decimalPart.length > 2 ? value.toFixed(2) : value
    }
    return '0.00' // 如果數值不存在或無效，回傳 '0.00'
  }

  const formattedReport = {
    userCount,
    openCount,
    openPercent: formatPercent(openPercent),
    linkCount,
    linkPercent: formatPercent(linkPercent),
    fileCount,
    filePercent: formatPercent(filePercent),
    textCount,
    textPercent: formatPercent(textPercent),
  }

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    SectionHeader({
      text: '第二章 執行摘要',
      size: 52,
      headingNumber: HeadingLevel.HEADING_1,
    }),
    new Paragraph({
      border: {
        top: {
          color: '#000000',
          style: BorderStyle.SINGLE,
          size: 25, // 控制橫線的粗細
        },
      },
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本文件提出對',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '的受測單位及受測對象進行社交工程郵件演練的結果。此項測試的目的是辨識出可能會因惡意郵件攻擊的狀況進行實測與分析，並給予改善建議。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '協助',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '檢視現有社交工程安全防護，並依照',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '之需求執行社交工程郵件演練，本專案檢測服務檢測時程為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          // text: `${moment(campaignStartDate).format(DATE_FORMAT_CN)} - ${moment(
          //   campaignEndDate,
          // ).format(DATE_FORMAT_CN)}`,
          text: `${parseDateToTaiwanDate(campaignStartDate)}至${parseDateToTaiwanDate(
            campaignEndDate,
          )}`,
          // bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
          underline: {}, // 加上下劃線
        }),
        new TextRun('。'),
      ],
    }),
    new Paragraph(''),

    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '本次社交工程',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: service,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '測試專案，著重於測試',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,

          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '的整體工作同仁對於惡意',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: service,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '之警覺性，以降低社交工程攻擊風險，檢測標的為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '內部指定電子郵件帳號進行檢測，每個電子郵件帳號進行',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${sendCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '封社交工程郵件測試，且每帳號',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${sendCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '封的測試郵件均可在客戶指定的時間範圍內分次不定期寄送，以達到最佳測試效果。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),

    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '依社交工程測試專案服務之要求，檢測郵件內容設計可涵蓋不同類型。本次',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '檢測範本內容可參考章節3.6之內容。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),

    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '第四章的測試分析結果整理出的報表、圖表會按照受測人數及檢測範本等各類不同面向的統計資訊，詳細列出了',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '在執行期間所檢測的各項檢測結果，以及建議解決方式。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '由檢測結果可得知本次受測對象共',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.userCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '人，總演練郵件數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${sendTotalCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '封，實際發送郵件數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${sendTotalCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '封，無法投遞郵件',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${sendFailCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '封，瀏覽測試郵件之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.openCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.openPercent || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '%；點閱測試連結之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.linkCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.linkPercent || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '%；開啟測試附件之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.fileCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.filePercent || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '%；輸入資料之人數為',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.textCount || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '人，占總受測人數的',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: `${formattedReport.textPercent || 0}`,
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '%。多數受測者具有相當警覺性，未瀏覽社交檢測信件，但仍有受測者未詳查寄件來源或身分，建議可針對此類受測者進行教育訓練，藉此訓練受測者自身資安意識的強化。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),

    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '為避免遭受有心人士利用，後續的解決方案除了教育訓練與自身資安意識的強化，也應當建立相關的資訊安全政策，並定期舉行教育訓練以及社交工程郵件演練，使其能夠在日新月異的技術變化之中，持續維持安全性。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
  ]
}

export default Chapter2Page
